<template>
  <div>
    <div style="height:60px" class="hidden-md-and-up"></div>
    <h2>Certificación de Abogadas(os)</h2>
    <v-layout row wrap>
      <v-flex sm7 xs12>
        <v-card class="text-sm-left">
          <v-toolbar
            color="default"
            primary-title
            class="title font-weight-bold elevation-0"
            centered
          >Verificación de Certificaciones</v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex lg4 md4 sm6 xs12>
                  <v-text-field
                    label="Codigo Certificado"
                    placeholder="Ingresa el Codigo de Certificado"
                    prepend-icon="qr_code_2"
                    :rules="requiredRule"
                    v-model="certificadoSearch.codigo"
                    box
                  ></v-text-field>
                </v-flex>
                <v-flex lg4 md4 sm6 xs12>
                  <div id="panelResultados"></div>
                  <v-dialog
                    ref="dialogFecha"
                    v-model="modalFecha"
                    :return-value.sync="certificadoSearch.fecha"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      class="required px-1"
                      v-model="computedDateFormatted"
                      label="Fecha Certificacion"
                      prepend-icon="event"
                      :rules="requiredRule"
                      readonly
                      hint="DD/MM/YYYY formato"
                      box
                      placeholder="Ingresa la fecha de emision del Certificado"
                    ></v-text-field>
                    <v-date-picker
                      ref="picker"
                      v-model="certificadoSearch.fecha"
                      scrollable
                      locale="es"
                      :max="new Date().toISOString().substr(0, 10)"
                    >
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modalFecha = false">Cancelar</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.dialogFecha.save(certificadoSearch.fecha)"
                      >OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex lg3 md3 sm12 xs12>
                  <v-btn
                    color="primary"
                    @click.prevent="buscarCertificacion()"
                    :loading="resultado"
                  >
                    <v-icon>search</v-icon>Verificar
                    <span slot="loader" dark>
                      <v-progress-circular size="20" indeterminate color="white"></v-progress-circular>
                    </span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>

            <div
              class="grey--text caption"
            >La presente información sirve para validar la fiabilidad de las certificaciones generadas por la plataforma de la Unidad de Registro Publico de la Abogacía</div>
            <div class="my-3">
              <v-layout row wrap v-if="noData">
                <v-alert
                  type="error"
                  outline
                  :value="true"
                >No se encuentra un Registro de Certificación con los parámetros de la búsqueda</v-alert>
              </v-layout>
              <v-layout row wrap v-if="!noData && certificado!=null">
                <v-flex md2 class="grey--text">Cite:</v-flex>
                <v-flex md10>{{certificado.cite}}</v-flex>
                <v-flex md2 class="grey--text">Solicitante :</v-flex>
                <v-flex md10>A peticion {{certificado.solicitante}}</v-flex>
                <v-flex md2 class="grey--text">Certifica :</v-flex>
                <v-flex md10>
                  <p>
                    <span
                      v-html="certificado.contenido"
                    ></span>
                  </p>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg5 sm5>
        <v-card class="elevation-9">
          <v-toolbar color="default" primary-title class="title font-weight-bold elevation-0">
              Solicitud de Certificación para Abogadas y Abogados 
              </v-toolbar>
          <v-card-text class="text-sm-left mx-2">
          
            <v-subheader>Requisitos y pasos</v-subheader>
            <v-layout row wrap class="px-2">
              <v-flex lg1 md1 sm1 xs1>
                <v-avatar icon :size="32">
                  <v-icon class="primary white--text" >account_circle</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex lg11 md11 sm11 xs11 class="px-3">
                <div class="font-weight-medium">Tener Cuenta de Ciudadanía Digital</div>
                <p class="caption grey--text">
                  ¿No tienes cuenta? <a href="https://www.gob.bo/ciudadania/registrate" target="_blank" class="blue--text" style="text-decoration: none">presiona aqui para registrarte</a>
                </p>
              </v-flex>
              <v-flex lg1 md1 sm1 xs1>
                <v-avatar icon :size="32">
                  <v-icon small class="primary white--text" >important_devices</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex lg11 md11 sm11 xs11 class="px-3">
                <div class="font-weight-medium">Ingresar al Sistema de Registro de la Abogacía</div>
                <v-btn
                color="primary lighten-3"
                @click="redirect('https://sra.justicia.gob.bo')"
                small
                round
              >
                <v-avatar size="20" class="px-3">
                  <img
                    :src="require('@/assets/rpablanco.png')"
                    alt="Logo del Registro Publico de la Abogacia"
                  />
                </v-avatar>presiona para ingresar a la Plataforma
              </v-btn>
              </v-flex>
              <v-flex lg1 md1 sm1 xs1>
                
              </v-flex>
              <v-flex lg11 md11 sm11 xs11 class="px-3">
                <div class="font-weight-medium">¿Necesitas saber más sobre el procedimiento de emisión de certificado?</div>
                <p class="caption grey--text">
                  <a href="https://youtu.be/JfhIXTYPROY" target="_blank" class="blue--text" style="text-decoration: none">presiona aqui para ver el video tutorial</a>
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <br/>
        <Requisito
          :requisitos="certificacionRequisito.requisitos"
          :titulo="certificacionRequisito.titulo"
          subheader="Requisitos"
        />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Requisito from "@/components/Registro/Requisito";
export default {
  components: { Requisito },
  data() {
    return {
      modalFecha: false,
      items: [],
      headers: [
        {
          text: "Departamento",
          aligin: "left",
          sortable: false,
          activo: true
        },
        {
          text: "Lugar",
          aligin: "left",
          sortable: false,
          activo: true
        },
        {
          text: "Fecha",
          aligin: "left",
          sortable: false,
          activo: true
        }
      ],
      valid: true,
      resultado: false,
      certificacionRequisito: {
        titulo: "Solicitud de Certificación para Teceros Interesados, Requerimiento Fiscal y Orden Judicial",
        requisitos: [
          {
            icon: "file_copy",
            iconClass: "primary white--text",
            title: "Nota de Solicitud",
            subtitle:
              "Dirigida a la Unidad de Registro Público de la Abogacía debiendo señalar su motivacion, acreditando el interes legal y el nombre completo del abogado de quien solicita el certificado, además debe señalar su correo electronico"
          },
          {
            icon: "contact_page",
            iconClass: "primary white--text",
            title: "Fotocopia simple de la Cédula de Identidad del Solicitante",
            subtitle: null
          },{
            icon: "event",
            iconClass: "primary white--text",
            title: "El plazo de entrega de la certificacion es de dos (2) días habiles",
            subtitle: "A partir de la recepcion en oficnas de la Direccion General del Registro Público de la Abogacía."          },
        ]
      },
      certificadoSearch: {
        codigo: this.$route.query.codigo || null,
        fecha: this.$route.query.fecha || null
      },
      certificado: null,
      noData: false,
      requiredRule: [v => !!v || "El campo no puede estar vacio"]
    };
  },
  mounted: function() {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(20);
    }
    if (this.$route.query.codigo && this.$route.query.fecha) {
      this.buscarCertificacion();
    }
  },
  computed: {
    computedDateFormatted: {
      get: function() {
        return this.formatDate(this.certificadoSearch.fecha);
      },
      set: function(data) {}
    }
  },
  methods: {
    buscarCertificacion() {
      if (this.$refs.form.validate()) {
        this.certificado = null;
        this.resultado = true;
        this.noData = false;
        this.$vuetify.goTo("#panelResultados", {});
        this.$http
          .get(`${this.$apiUrl}publico/certificacion`, {
            params: this.certificadoSearch
          })
          .then(response => {
            this.resultado = false;
            this.certificado = response.data.data;
          })
          .catch(error => {
            this.resultado = false;
            if (error.response.status == 404) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "Error en la peticion al servidor"
              );
            }
            if (error.response.status == 400) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "El codigo y la fecha de la certificacion No es valida"
              );

              this.noData = true;
            }
            if (error.response.status == 500) {
              this.$store.commit('setErrorColor','error')
              this.$store.commit(
                "setError",
                "Formato de parametros incorrectos"
              );
            }
          });
      }
    },
    abogadoCertificado(data) {
      if (data.abogado == null) {
        return data.abogadoSinRegistro;
      } else {
        return data.abogado;
      }
    },
    formatDate(date) {
      if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date;
    },
     redirect(url) {
      window.open(url);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Certificacion/Certificacion.vue